import { jsx as t, jsxs as d } from "react/jsx-runtime";
import { ChevronLeftIcon as T, CloseIcon as $ } from "../../icons/index.es.js";
import { forwardRef as c } from "react";
import { IconButton as x, Button as O } from "../Button/Button.es.js";
import { ModalBody as V, ModalFooter as v, Flex as B, ModalHeader as y, useBreakpointValue as g, useMultiStyleConfig as j, Modal as w, ModalOverlay as E, useModalContext as S, ModalContent as R } from "@chakra-ui/react";
import { c as q } from "../../index-226b8ea6.js";
import { Heading as A, HeadingSizes as G } from "../Heading/Heading.es.js";
import "../Heading/Heading.styles.es.js";
import { Paragraph as J } from "../Paragraph/Paragraph.es.js";
import { SmartButton as K } from "../SmartButton/SmartButton.es.js";
import { TextLink as N } from "../TextLink/TextLink.es.js";
const [Q, s] = q({
  name: "ModalStylesContext",
  errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
}), so = ({
  autoFocus: o = !0,
  children: e,
  closeOnEsc: n = !0,
  closeOnOverlayClick: a = !0,
  disableModalContent: l = !1,
  isMobileFullscreen: r = !1,
  motionPreset: i = "scale",
  returnFocusOnClose: m = !1,
  size: u,
  ssr: M = !0,
  trackId: k,
  variant: z,
  ...D
}) => {
  const b = g(
    {
      base: "slideInBottom",
      md: i
    },
    {
      ssr: M
    }
  ), H = g(
    {
      base: "full",
      sm: u
    },
    {
      ssr: M
    }
  ), p = j("ModalTheme", {
    size: r ? H : u,
    variant: z
  }), { isOpen: L, onEsc: P, onCloseComplete: F, onOverlayClick: I, ...h } = D;
  return /* @__PURE__ */ t(
    w,
    {
      autoFocus: o,
      closeOnEsc: n,
      closeOnOverlayClick: a,
      motionPreset: r ? b : i,
      returnFocusOnClose: m,
      isOpen: L,
      onEsc: P,
      onCloseComplete: F,
      onOverlayClick: I,
      ...h,
      children: /* @__PURE__ */ d(Q, { value: p, children: [
        /* @__PURE__ */ t(E, { ...p.overlay, ...h }),
        l ? e : /* @__PURE__ */ t(W, { trackId: k, children: e })
      ] })
    }
  );
}, io = c(
  ({ children: o }, e) => /* @__PURE__ */ t(V, { ref: e, ...s().body, children: o })
), co = c(
  ({ children: o }, e) => /* @__PURE__ */ t(v, { ref: e, ...s().footer, children: o })
), f = ({
  ariaLabel: o,
  component: e,
  title: n,
  ...a
}) => e === "TextLink" ? /* @__PURE__ */ t(N, { variant: "transparent", "aria-label": o, ...a, children: n }) : e === "SmartButton" ? /* @__PURE__ */ t(K, { "aria-label": o, ...a, children: n }) : /* @__PURE__ */ t(O, { "aria-label": o, ...a, children: n }), mo = c(
  ({ primary: o, secondary: e, tertiary: n }, a) => {
    const l = [o, e, n].filter(Boolean).length, r = s(), i = {
      ...r.footer,
      ...r.footerDefault
    };
    return /* @__PURE__ */ d(v, { ref: a, ...i, children: [
      n && /* @__PURE__ */ t(
        f,
        {
          sx: {
            order: l === 3 ? { base: 1, sm: 0 } : void 0
          },
          variant: n.component === "TextLink" ? void 0 : "transparent",
          ...n
        }
      ),
      /* @__PURE__ */ d(
        B,
        {
          flexBasis: l === 3 ? { base: "100%", sm: "inherit" } : void 0,
          gap: 2,
          marginLeft: { base: void 0, sm: "auto" },
          children: [
            e && /* @__PURE__ */ t(
              f,
              {
                variant: e.component === "TextLink" ? void 0 : "tertiary",
                sx: {
                  flex: 1
                },
                ...e
              }
            ),
            o && /* @__PURE__ */ t(
              f,
              {
                sx: {
                  flex: 1
                },
                ...o
              }
            )
          ]
        }
      )
    ] });
  }
), fo = c(
  ({ children: o, sx: e }, n) => /* @__PURE__ */ t(y, { ref: n, ...s().header, sx: e, children: o })
), uo = c(
  ({ button: o, title: e, subtitle: n }, a) => {
    const l = s(), r = {
      ...l.header,
      ...l.headerDefault
    };
    return /* @__PURE__ */ d(y, { ref: a, ...r, children: [
      o && /* @__PURE__ */ t(
        x,
        {
          "aria-label": o.ariaLabel,
          icon: o.icon ?? /* @__PURE__ */ t(T, { boxSize: 4 }),
          onClick: o.onClick,
          size: "sm",
          variant: "transparent"
        }
      ),
      /* @__PURE__ */ d(B, { flexDirection: "column", gap: 2, children: [
        typeof e == "string" ? /* @__PURE__ */ t(A, { size: G.MD, children: e }) : e,
        n && typeof n == "string" ? /* @__PURE__ */ t(J, { size: "md", color: "primary.400", children: n }) : n
      ] })
    ] });
  }
), C = c((o, e) => /* @__PURE__ */ t(
  x,
  {
    ref: e,
    variant: "transparent",
    icon: /* @__PURE__ */ t($, { boxSize: 4 }),
    size: "sm",
    ...o
  }
)), U = (o) => {
  const { onClose: e } = S();
  return /* @__PURE__ */ t(
    C,
    {
      ...s().closeButton,
      as: C,
      onClick: e,
      "aria-label": "Close",
      ...o
    }
  );
}, W = ({
  as: o,
  trackId: e,
  children: n
}) => {
  const { getDialogProps: a, getDialogContainerProps: l } = S(), r = s();
  let i = a(r.dialog);
  const m = l(r.dialogContainer);
  return /* @__PURE__ */ d(
    R,
    {
      ...i,
      as: o,
      containerProps: { ...m, "track-id": e },
      sx: {
        "&:not(:has(> footer)) > div": {
          paddingBottom: 5
        }
      },
      children: [
        /* @__PURE__ */ t(U, {}),
        n
      ]
    }
  );
};
export {
  so as Modal,
  io as ModalBody,
  W as ModalContent,
  co as ModalFooter,
  mo as ModalFooterDefault,
  fo as ModalHeader,
  uo as ModalHeaderDefault
};
//# sourceMappingURL=Modal.es.js.map
